/**
 * The brand panel of the split layout grows on wide screens (user decision
 * 7.10.2026): at 1440px it is exactly Karo's board (560px), below it keeps its
 * share of the viewport as before, beyond it grows with the viewport up to
 * 760px. Its spacing scales by the same factor through `fluid`; its type keeps
 * the board's sizes at every width (user decision 7.10.2026).
 */

/** The viewport width of Karo's boards, where the panel has its board size. */
const BOARD_VIEWPORT = 1440;
const PANEL_BOARD_WIDTH = 560;
const PANEL_MAX_WIDTH = 760;

/** How far the panel and its spacing grow beyond the board size. */
export const BRAND_PANEL_MAX_SCALE = PANEL_MAX_WIDTH / PANEL_BOARD_WIDTH;

const round = (value: number) => Number(value.toFixed(3));

/**
 * A size of the board that stays as it is up to 1440px and then grows with the
 * viewport, at most by `BRAND_PANEL_MAX_SCALE`.
 */
export const fluid = (px: number): string =>
  `clamp(${px}px, ${round((px / BOARD_VIEWPORT) * 100)}vw, ${round(
    px * BRAND_PANEL_MAX_SCALE
  )}px)`;

/**
 * The flex basis of a side panel that is `width` px wide at 1440px: `share` %
 * of the viewport below (the earlier rule), the board's proportion of the
 * viewport beyond, never wider than its board width scaled by
 * `BRAND_PANEL_MAX_SCALE`.
 */
export const brandPanelBasis = ({
  width,
  share,
}: {
  width: number;
  share: number;
}): string =>
  `min(${round(width * BRAND_PANEL_MAX_SCALE)}px, ${share}%, max(${width}px, ${round(
    (width / BOARD_VIEWPORT) * 100
  )}%))`;
